<template>
  <q-page>
    <div class="be-main-lr" style="max-width: 750px; margin: 0 auto">
      <div class="be-page-title q-mt-md q-mb-md" v-html="$t('legal.title')"></div>
      <q-tabs no-caps inline-label indicator-color="dark" align="justify" narrow-indicator>
        <q-route-tab
          to="/legal/terms-and-conditions"
          replace
          :label="$t('legal.terms-and-conditions')"
          :title="$t('legal.terms-and-conditions')"
        />
        <q-route-tab
          to="/legal/cookie-policy"
          replace
          :label="$t('legal.cookie-policy')"
          :title="$t('legal.cookie-policy')"
        />
        <q-route-tab
          to="/legal/privacy-policy"
          replace
          :label="$t('legal.privacy-policy')"
          :title="$t('legal.privacy-policy')"
        />
      </q-tabs>
      <q-separator />
      <div class="q-mt-md" v-html="pageStore.info.content" />
    </div>
  </q-page>
</template>

<script>
import { createMetaMixin } from 'quasar'

import { mapState, mapStores } from 'pinia'
import { usePageStore } from 'stores/page'
import { useSettingsStore } from 'stores/settings'

export default {
  name: 'LegalPage',
  mixins: [
    createMetaMixin(function mymeta() {
      return {
        title:
          this.pageStore.info.seo_title !== null
            ? this.pageStore.info.seo_title
            : `${this.pageStore.info.name} - ${this.websiteName}`,
        meta: {
          description: {
            name: 'description',
            content:
              this.pageStore.info.seo_description !== null
                ? this.pageStore.info.seo_description
                : this.pageStore.info.description
          }
        }
      }
    })
  ],
  preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store)
    return new Promise(resolve => {
      if (
        currentRoute.params.type === 'privacy-policy' ||
        currentRoute.params.type === 'terms-and-conditions' ||
        currentRoute.params.type === 'cookie-policy'
      ) {
        pageStore.fetchByType(currentRoute.params.type).then(() => {
          resolve()
        })
      }
    })
  },
  computed: {
    ...mapStores(usePageStore),
    ...mapState(useSettingsStore, {
      websiteName: store => store.website.name
    })
  },
  beforeUnmount() {
    this.pageStore.clearInfo()
  }
}
</script>
